<template>
    <div class="list_nav_wrap">
        <h1 class="list_nav_title clearfix">
            <label>品牌</label><a href="#" class="nav_list_more">更多 » </a>
        </h1>
        <ul click_type="sale-brands" class="clearfix findall">
            <li v-for="item in list">
                <a :class="{
                        'listNav_active': active === item.brand
                    }"
                    click_type="list-nav-brand-dazhong"
                    @click="doSelect(item.brand)">
                    {{ item.brandName }}
                </a>
            </li>
        </ul>
        <div click_type="sale-all-brands" class="list_allBrand clearfix" style="display: none; width: 0px;">
            <p>所有品牌</p>
            <div class="list_allBrand_wrap">
                <div class="allBrand_contain">
                    <dl v-for="(groupValue, groupName) in listMoreByLetter"
                        class="clearfix">
                        <dt>{{ groupName }}</dt>
                        <dd>
                            <a v-for="item in groupValue"
                                @click="doSelect(item.code)">
                                {{ item.name }}
                            </a>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <span class="cover"></span>
    </div>
</template>

<script>
    import {
        shopBrands
    } from '../../../../api/defaultApi.js';
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    // // let formBean = window._qiwa.page_global.formBean;
    export default {
        data() {
            return {
                key: 'carBrand',
                active: locationObj.search.get('carBrand'),
                list: window._qiwa.site_global.hot_brand_list,
                listMore: []
            };
        },
        computed: {
            listMoreByLetter() {
                var ret = {};
                this.listMore.forEach(function (v) {
                    if (!ret[v.initialsLetter]) {
                        ret[v.initialsLetter] = [];
                    }
                    ret[v.initialsLetter].push(v);
                });
                return ret;
            }
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value)
                        .s('index', null).go();
                } else {
                    locationObj.s(this.key, null)
                        .s('index', null).go();
                }
                locationObj.s('carSeries', null)
                    .s('index', null).go();
            }
        },
        created() {
            shopBrands().then((data) => {
                this.listMore = data;
            });
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavBrand.vue?1bb0a0da